import React, { ReactElement } from 'react';

export default function PlaceholderView(): ReactElement {
  return <></>;
}
